import { useNavigate } from "react-router-dom";
import { parseAsString, useQueryState } from "nuqs";
import { TimeLineWidget, TimeLineWeekWidget, TimelineNav } from "../../../widgets/timeline";
import { useTimelineView } from "../../../features/timeline-navigation";
import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";
import { routes } from "../../../shared/config/routes";

function toDateKey(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export const Calendar = () => {
  const navigate = useNavigate();
  const { view, setView } = useTimelineView();
  const [dayKey, setDayKey] = useQueryState('day', parseAsString.withDefault(''));

  const handleDayClick = (dayKey: string) => {
    setDayKey(toDateKey(new Date(dayKey + 'T00:00:00')));
    setView('day');
  };

  return (
    <PageLayout
      pageTitle="Kalender"
      headerChildren={<TimelineNav />}
      primaryAction={{
        label: "Disposition",
        onClick: () => {
          const params = new URLSearchParams();
          if (view) params.set('view', view);
          if (dayKey) params.set('day', dayKey);
          const qs = params.toString();
          navigate(`${routes.disposition.root}${qs ? `?${qs}` : ''}`);
        },
      }}
    >
      {view === 'day' ? (
        <TimeLineWidget readonly />
      ) : (
        <TimeLineWeekWidget onDayClick={handleDayClick} />
      )}
    </PageLayout>
  );
};
